/**
 * @file Custom T-Shirts
 */

/**
 * Custom T-Shirts Template functions
 *
 * Runs js specific to the Custom T-Shirts template.
 */
const vCustomTshirts = () => {
	import('../../components/hp-carousel/hp-carousel').then(({ default: vHpCarousel }) => { vHpCarousel(); });
};

if (document.readyState !== 'loading') {
	vCustomTshirts();
} else {
	document.addEventListener('DOMContentLoaded', vCustomTshirts);
}
